import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=3864d804&scoped=true&"
import script from "./Consent.vue?vue&type=script&lang=js&"
export * from "./Consent.vue?vue&type=script&lang=js&"
import style0 from "./Consent.vue?vue&type=style&index=0&id=3864d804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864d804",
  null
  
)

export default component.exports